<template>
  <div>
    <!-- 面包屑导航 -->

    <el-page-header @back="goBack" content="乐刷进件详情">
    </el-page-header>

    <el-card class="box-card" style="margin-top:20px">
      <el-form
        :inline="true"
        :model="ruleForm"
        ref="formForRef"
        label-width="110px"
        autocomplete="on"
        size="mini"
      >
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="商户基本信息" name="company">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="商户名称">
                  <el-input placeholder="请输入商户名称" v-model="ruleForm.merchant_name" type="text">
                    <span @click="choosePosMember" slot="suffix" style="color: #ff0000;">...</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="商户类型">
                  <el-select v-model="ruleForm.type_id"  placeholder="请选择商户类型"  @change="handleIsopenSelect">
                    <el-option :key="item.id"  v-for="item in typeList" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="商户简称">
                  <el-input placeholder="请输入商户简称" v-model="ruleForm.short_name" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="客服电话">
                  <el-input placeholder="请输入客服电话" v-model="ruleForm.service_phone" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="商户行业编号">
                  <el-input placeholder="请输入MCC码商户行业编号" v-model="ruleForm.mcc_code" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="证件类型">
                  <el-select v-model="ruleForm.licence_type" placeholder="请选择证件类型">
                    <el-option :key="item.id"  v-for="item in licenceTypeList" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="营业执照名称">
                  <el-input placeholder="请输入营业执照名称" v-model="ruleForm.licence_full_name" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="统一代码">
                  <el-input placeholder="请输入统一代码" v-model="ruleForm.licence_no" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">

              <el-col :span="8">
                <el-form-item label="有效期开始日期">
                  <el-date-picker
                    v-model="ruleForm.licence_start"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结束日期">
                  <div style="display: flex;flex-direction: row">
                  <el-date-picker
                    v-model="ruleForm.licence_end"
                    type="date"
                    placeholder="选择有效结束日期"
                    value-format="yyyy-MM-dd"
                    style="width:140px"
                  />
                  <el-checkbox @change="longChange" v-model="ruleForm.isLong">长期</el-checkbox>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="注册地址">
                  <el-input placeholder="请输入营业执照注册地址" v-model="ruleForm.licence_address" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col>
                <el-row>
                  <el-col>
                    <el-form-item label="营业执照图片">
                      <el-upload
                        class="upload-demo"
                        drag
                        action="#"
                        :before-upload="handleBeforeUpload"
                        :on-success="uploadSuccess"
                        :auto-upload="false"
                        :on-change="uploadFile"
                        :file-list="fileList"
                        list-type="picture"
                        multiple
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="商户地址信息" name="dzxx" >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="所属省市">
                  <el-cascader
                    ref="cascaderAddr"
                    style="width: 90%"
                    v-model="areaList"
                    :props="propsdata"
                    :key="isResouceone"
                    @change="handleChangeAddress"
                  >
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="详细地址信息">
                  <el-input placeholder="请输入详细地址信息" v-model="ruleForm.address" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="法人信息" name="frxx" >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="身份证正面">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证反面">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手持身份证">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">

              <el-col :span="8">
                <el-form-item label="证件类型">
                  <el-select v-model="ruleForm.credential_type" style="width: 200px;" placeholder="请选择证件类型"  @change="handleIsopenSelect">
                    <el-option :key="item.id"  v-for="item in credentialTypeList" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有效期开始日期" size="small">
                  <el-date-picker clearable type="date" placeholder="选择有效期开始日期" v-model="ruleForm.card_valid_sdate" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="有效期结束日期" size="small">

                  <div style="display: flex;flex-direction: row">
                    <el-date-picker
                      v-model="ruleForm.card_valid_edate"
                      type="date"
                      placeholder="选择有效期结束日期"
                      value-format="yyyy-MM-dd"
                      style="width:140px"
                    />
                    <el-checkbox @change="longChange" v-model="ruleForm.isLinkLong">长期</el-checkbox>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="法人姓名">
                  <el-input placeholder="请输入法人姓名" v-model="ruleForm.link_person" type="text"></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="证件号">
                  <el-input placeholder="请输入证件号" v-model="ruleForm.credential_code" type="text"></el-input>
                </el-form-item>
              </el-col>

            </el-row>

          </el-tab-pane>
          <el-tab-pane label="商户结算信息" name="await_pay">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="账户类型">
                  <el-select v-model="ruleForm.account_type" style="width: 200px;" placeholder="请选择账户类型"  @change="handleIsopenSelect">
                    <el-option :key="item.id"  v-for="item in accountTypeList" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结算标志">
                  <el-select v-model="ruleForm.legal_flag" style="width: 200px;" placeholder="请选择结算标志"  @change="handleIsopenSelect">
                    <el-option :key="item.id"  v-for="item in legalFlagList" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开户支行联行号">
                  <el-input placeholder="请输入开户支行联行号" v-model="ruleForm.unionpay" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="开户名">
                  <el-input placeholder="请输入开户名" v-model="ruleForm.bank_account_name" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结算人证件">
                  <el-input placeholder="请输入结算人证件" v-model="ruleForm.account_idcard_no" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结算人证件类型">
                  <el-select v-model="ruleForm.account_idcard_type" style="width: 200px;" placeholder="请选择结算人证件类型"  @change="handleIsopenSelect">
                    <el-option :key="item.id"  v-for="item in cateMenus" :label="item.pid>0?'|--'+item.name:item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="银行预留号码">
                  <el-input placeholder="请输入银行预留号码" v-model="ruleForm.phone" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="银行卡号">
                  <el-input placeholder="请输入银行卡号" v-model="ruleForm.bank_account" type="text"></el-input>
                </el-form-item>
              </el-col>
<!--              <el-col :span="8">-->
<!--                <el-form-item label="是否校验银行卡">-->
<!--                  <el-select v-model="ruleForm.cat_id" style="width: 200px;" placeholder="请选择是否校验银行卡"  @change="handleIsopenSelect">-->
<!--                    <el-option :key="item.id"  v-for="item in cateMenus" :label="item.pid>0?'|&#45;&#45;'+item.name:item.name" :value="item.id"></el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
            </el-row>

            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="非法人证件开始" size="small">
                  <el-date-picker clearable type="date" placeholder="选择非法人证件开始日期" v-model="ruleForm.idcard_start" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="非法人证件结束" size="small">
                  <el-date-picker clearable type="date" placeholder="选择非法人证件结束日期" v-model="ruleForm.idcard_end" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="银行卡正面">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="商户门店信息" name="shmdxx">
            <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="店铺类型">
                <el-select v-model="ruleForm.shop_type" style="width: 200px;" placeholder="请选择结店铺类型"  @change="handleIsopenSelect">
                  <el-option :key="item.id"  v-for="item in shopTypeList" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
              <el-col :span="8">
                <el-form-item label="总店商户号">
                  <el-input placeholder="请输入总店商户号" v-model="ruleForm.head_merchant_id" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结算对象">
                  <el-select v-model="ruleForm.settle_to" style="width: 200px;" placeholder="请选择结算对象"  @change="handleIsopenSelect">
                    <el-option :key="item.id"  v-for="item in settleToList" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="经营场所内设照片">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="门头照">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收银台照片">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="微信配置信息" name="wxpxxx">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="联系人微信号">
                  <el-input placeholder="请输入联系人微信号" v-model="ruleForm.user_wx" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="微信公众号支付appid">
                  <el-input placeholder="请输入微信公众号支付appid" v-model="ruleForm.sub_appid" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="微信公众号授权目录">
                  <el-input placeholder="请输入微信公众号授权目录" v-model="ruleForm.jsapi_path" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="其他附属信息" name="qtfsxx">

          </el-tab-pane>
          <el-tab-pane label="联系人信息" name="link">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="姓名">
                  <el-input placeholder="请输入姓名" v-model="ruleForm.contact_name" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份证号">
                  <el-input placeholder="请输入身份证号" v-model="ruleForm.contact_idcard_no" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电话">
                  <el-input placeholder="请输入电话" v-model="ruleForm.contact_mobile" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="服务商信息" name="source">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="服务商编号">
                  <el-input placeholder="请输入服务商编号" v-model="ruleForm.agent_id" type="text">
                    <div  slot="suffix" >
                    <el-tooltip placement="top">
                      <div slot="content">由乐刷分配的接入方唯一标识，明文传输</div>
                      <i class="el-input__icon el-icon-warning-outline">
                      </i>
                    </el-tooltip>
                    </div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- 卡片 -->

      <eChoosePosMemberList
        :formData="formData"
        :visible.sync="visible"
        :title="title"
        :closeForm="closeForm"
      />

    </el-card>
  </div>
</template>
<script>
  import eChoosePosMemberList from "../common/eChoosePosMemberList.vue";
  import axios from 'axios'
  import CryptoJS from "crypto-js";
  export default {
    components: {eChoosePosMemberList},
    data() {
      return {

        formData:{},
        title: '',
        visible:false,

        typeList:[],
        licenceTypeList:[],
        credentialTypeList:[],
        accountTypeList:[],
        legalFlagList:[{id:0,name:'非法人结算'},{id:1,name:'法人结算'}],
        shopTypeList:[{id:0,name:'分店'},{id:1,name:'总店'}],
        settleToList:[{id:0,name:'独立结算'},{id:1,name:'合并结算至总店'}],

        fileList:[],
        activeName:'company',

        ruleForm:{
          isLong:false,
          isLinkLong:false,
          mcc_code:'',
          type_id:'',
          service_phone:'',
          id:'',
          title:'',
          update_time:'',
          cat_id:'',
          licence_type:'',
          licence_url:'',
          licence_name_url:'',
          upload_id:'',

          licence_no:'',
          licence_address:'',
          licence_full_name:'',
          licence_start:'',
          licence_end:'',
          merchant_name:'',
          merchant_id:'',
          short_name:'',
          pay_source:'',
          proxy_id:sessionStorage.getItem('proxy_id'),
          address:'',
          province_id:'',
          city_id:'',
          district_id:'',
          contact_mobile:'',
          contact_idcard_no:'',
          contact_name:'',
          jsapi_path:'',
          sub_appid:'',
          user_wx:'',
          credential_type:'',
          credential_code:'',
          link_person:'',
          card_valid_sdate:'',
          card_valid_edate:'',
          account_type:'',
          legal_flag:'',
          bank_account_name:'',
          unionpay:'',
          account_idcard_no:'',
          account_idcard_type:'',
          phone:'',
          bank_account:'',
          shop_type:'',
          head_merchant_id:'',
          settle_to:''
        },
        cateMenus:[],
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        areaList:[],
        isResouceone: false,
        propsdata: {
          // 懒加载地区列表
          lazy: true,
          lazyLoad(node, resolve) {
           // const { level } = node;
            console.log(node)
            let url= '/api/api/cmp.sys.Region_read_lz/findRegionList';
            setTimeout(() => {
              // 第一級
              if (node.level == 0) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
               // var _this=this;

                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:1
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                });
              }
              // 第二級
              if (node.level == 1) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
                // var _this=this;
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                });
              }
              if (node.level == 2) {
                // Ajax請求數據，填充選擇框
                // // 接口请求获取省份
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: true,
                    }));
                    resolve(nodes);
                  }
                });
              }
            }, 100);
          },
        },
      }
    },
    mounted() {
     this.getDicList('memberType');
      this.getDicList('licenceType');
      this.getDicList('credentialType');
      this.getDicList('accountType');
      var id= this.$route.query.id;
      if(!isNaN(id)&&id>0){
        this.ruleForm.id=id;
        this.getOne();
      }

    },
    methods: {
      closeForm(){
        this.title="";
        this.visible=false;
        console.log('999----',this.formData)
        this.ruleForm.merchant_id=this.formData.id;
        this.ruleForm.merchant_name=this.formData.name;
      },
      choosePosMember(){
        this.title="商家选择";
        this.visible=true;
      },
      handleChangeAddress(){     // 更改时调用
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.ruleForm.province_id=checkedNode[0].path[0];
        _this.ruleForm.city_id=checkedNode[0].path[1];
        _this.ruleForm.district_id=checkedNode[0].path[2];

      },
      longChange(e){
        console.log('0000----',e)
      },

      goBack() {
        this.$router.go(-1);
      },
      resetForm(){

      },
      getDicList(code){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:code,
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            if(code=='memberType'){
              this.typeList=res.data;
            }else if(code=='licenceType'){
              this.licenceTypeList=res.data;
            }
            else if(code=='credentialType'){
              this.credentialTypeList=res.data;
            }
            else if(code=='accountType'){
              this.accountTypeList=res.data;
            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      submitForm(){
        let _this=this;
        const param = {
          proxy_id:sessionStorage.getItem('proxy_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          merchant_name:_this.ruleForm.merchant_name,
          merchant_id:_this.ruleForm.merchant_id,
          short_name:_this.ruleForm.short_name,
          type_id:_this.ruleForm.type_id,
          service_phone:_this.ruleForm.service_phone,
          mcc_code:_this.ruleForm.mcc_code,
          licence_no:_this.ruleForm.licence_no,
          licence_type:_this.ruleForm.licence_type,
          licence_url:_this.ruleForm.licence_url,
          licence_address:_this.ruleForm.licence_address,
          licence_full_name:_this.ruleForm.licence_full_name,
          licence_start:_this.ruleForm.licence_start,
          province_id:_this.ruleForm.province_id,
          city_id:_this.ruleForm.city_id,
          district_id:_this.ruleForm.district_id,
          address:_this.ruleForm.address,
          contact_name:_this.ruleForm.contact_name,
          contact_mobile:_this.ruleForm.contact_mobile,
          contact_idcard_no:_this.ruleForm.contact_idcard_no,
          jsapi_path:_this.ruleForm.jsapi_path,
          sub_appid:_this.ruleForm.sub_appid,
          user_wx:_this.ruleForm.user_wx,
          credential_type:_this.ruleForm.credential_type,
          credential_code:_this.ruleForm.credential_code,
          link_person:_this.ruleForm.link_person,
          card_valid_sdate:_this.ruleForm.card_valid_sdate,
          account_type:_this.ruleForm.account_type,
          legal_flag:_this.ruleForm.legal_flag,

          bank_account_name:_this.ruleForm.bank_account_name,
          unionpay:_this.ruleForm.unionpay,
          account_idcard_no:_this.ruleForm.account_idcard_no,
          account_idcard_type:_this.ruleForm.account_idcard_type,
          phone:_this.ruleForm.phone,
          bank_account:_this.ruleForm.bank_account,
          shop_type:_this.ruleForm.shop_type,
          settle_to:_this.ruleForm.settle_to,
          head_merchant_id:_this.ruleForm.head_merchant_id,
        }
        if(_this.ruleForm.type_id){
         let tmp= this.typeList.find(item=>item.id==_this.ruleForm.type_id);
          param.type_code=tmp.code;
        }

        if(this.ruleForm.isLong==true){
          param.licence_end="长期";
        }else{
          param.licence_end=_this.ruleForm.licence_end;
        }
        if(this.ruleForm.isLinkLong==true){
          param.card_valid_edate="长期";
        }else{
          param.card_valid_edate=_this.ruleForm.card_valid_edate;
        }
        if(_this.ruleForm.id){
          param.id=_this.ruleForm.id;
        }

        this.$axios.lsRegister(param).then(res=>{
          if(res.code == 200){
              this.$message.success("保存成功");
              //this.$router.push('/posMemberLsList')
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getOne(){
        let _this=this;
        let param={
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id:_this.ruleForm.id,
        };
        this.$axios.posMemberLsOne(param).then((res)=>{
          if(res.code==200){
            let item=res.data;
            _this.ruleForm.merchant_name=item.posmember.merchant_name;
            _this.ruleForm.short_name=item.posmember.short_name;
            _this.ruleForm.shop_id= item.shop_id;
            _this.ruleForm.proxy_id= item.proxy_id;
            _this.ruleForm.type_id=item.type_id;
            _this.ruleForm.service_phone=item.service_phone;
            _this.ruleForm.mcc_code=item.mcc_code;

            _this.ruleForm.licence_no=item.licence_no;
            _this.ruleForm.licence_type=item.licence_type;
            _this.ruleForm.licence_url=item.licence_url;
            _this.ruleForm.licence_full_name=item.licence_full_name;
            _this.ruleForm.licence_start=item.licence_start;

            _this.ruleForm.province_id=item.province_id;
            _this.ruleForm.city_id=item.city_id;
            _this.ruleForm.district_id=item.district_id;
            _this.ruleForm.address=item.address;
            if(item.city_id){
              _this.areaList=[item.province_id,item.city_id,item.district_id];
            }

            _this.ruleForm.contact_name=item.contact_name;
            _this.ruleForm.contact_mobile=item.contact_mobile;
            _this.ruleForm.contact_idcard_no=item.contact_idcard_no;
            _this.ruleForm.user_wx=item.user_wx;
            _this.ruleForm.sub_appid=item.sub_appid;
            _this.ruleForm.jsapi_path=item.jsapi_path;
            _this.ruleForm.credential_type=item.credential_type;
            _this.ruleForm.link_person=item.link_person;
            _this.ruleForm.credential_code=item.credential_code;
            _this.ruleForm.card_valid_sdate=item.card_valid_sdate;

            if(item.card_valid_edate=='长期'){
              _this.ruleForm.isLinkLong=true;

            }else{
              _this.ruleForm.card_valid_edate=item.card_valid_edate;
            }

            if(item.licence_end=='长期'){
              _this.ruleForm.isLong=true;
            }else{
              _this.ruleForm.licence_end=item.licence_end;
            }
            _this.ruleForm.licence_address=item.licence_address;

            _this.ruleForm.account_type=item.account_type;
            _this.ruleForm.legal_flag=item.legal_flag;

             _this.ruleForm.bank_account_name=item.bank_account_name;
            _this.ruleForm.unionpay=item.unionpay;
            _this.ruleForm.account_idcard_no=item.account_idcard_no;
            _this.ruleForm.account_idcard_type=item.account_idcard_type;
            _this.ruleForm.phone=item.phone;
            _this.ruleForm.bank_account=item.bank_account;
            _this.ruleForm.head_merchant_id=item.head_merchant_id;
            _this.ruleForm.shop_type=item.shop_type;
            _this.ruleForm.settle_to=item.settle_to;

          }
          console.log(res);
        });
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      async uploadFile (item) {
        let _this=this;
        let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;

        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => {
          file_md5 = md5;
          console.log('MD5:', md5)
        });
        await this.calculateSHA1(file).then(sha1 => {
          file_sha1 = sha1;
          console.log('SHA1:', sha1);
        });

        // 获取文件名
        const fileName = file.name;
        // 获取文件大小
        const fileSize = file.size;
        // 获取文件后缀
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
        console.log('文件名称：', fileName);
        console.log('文件后缀：', fileExtension);
        console.log('文件大小：', fileSize);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };
        this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200) {
            //文件已经存在
            _this.ruleForm.licence_url = res.data.url;
            var img = {
              name: res.data.name,
              url: res.data.url
            }
            _this.fileList.push(img);

          } else {
            formData.append('file', file);
            formData.append('csn',sessionStorage.getItem('csn'));
            // let param={
            //   access_token:sessionStorage.getItem('token'),
            //   company_id:sessionStorage.getItem('company_id')
            // };
            this.$axios.ossLocalUploadFile(formData).then(res => {
              //请求成功，触发then中的函数
              console.log('lu------888---upload -res--------',res)
              var fullurl=res.data;
              var fileurl=res.path;
              _this.ruleForm.licence_url=fullurl;
              _this.ruleForm.licence_name_url=file.name;
              var img={
                name:_this.ruleForm.licence_name_url,
                url:_this.ruleForm.licence_url
              }
              _this.fileList.push(img);
              //更新上传资料
              let upload_params = {
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                name: fileName,
                size: fileSize,
                ext: fileExtension,
                md5: file_md5,
                sha1: file_sha1,
                path: fileurl,
                url: fullurl,
                status: 1,
              };
              console.log('upload---save params', upload_params)
              _this.$axios.uploadSave(upload_params).then(resu => {
                _this.ruleForm.upload_id=resu.data.id;
                console.log('upload---save', resu)
              }).catch(error=>{
                console.log('upload---error', error)
              });
            })


          }
        });
      },
      async readFileAsBinaryString(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsBinaryString(file);
        });
      },
      async  calculateMD5(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.MD5(words).toString();
        });
      },
      async calculateSHA1(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.SHA1(words).toString();
        });
      },

      handleTabClick(tab,event){
        console.log(tab, event);
        if(tab.index==0){
          //_this.ruleForm.order_status_code='await_ship'
        }
        else if(tab.index==1){
          //_this.ruleForm.order_status_code='await_pay'
        }else if(tab.index==2){
          // _this.ruleForm.order_status_code='all'
        }
        // _this.getList();
      },
      handleIsopenSelect(){

      },
      getCateMenus(){
        let _this = this;
        let url= '/api/api/cms.Category_read_lz/findTable';
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        axios.post(url,params).then((res)=>{
          if(res.data.code == 200) {
            _this.cateMenus=res.data.data;
          }
        });
        _this.submit=false;
      },
      uploadImg(file, insertFn){

        let _this=this;
        let param={
          access_token: sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJson(param).then(res=>{
          console.log('ali_json------',res)

          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

          // let fParam=
          //  {
          //    name:file.name,
          //    key:key +'mrh/'+ autoname + suffix,
          //    policy:data['policy'],
          //    OSSAccessKeyId:data['accessid'],
          //    success_action_status:'200',
          //    callback:data['callback'],
          //    Signature:data['signature'],
          //    file:file
          //  };
          //
          //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}

          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key +'mrh/'+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);


          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )

        });

      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>

